/* eslint-disable max-len */
const messages = {
  'datepicker.today': 'Today',
  'datepicker.yesterday': 'Yesterday',
  'datepicker.this_week': 'This week',
  'datepicker.last_week': 'Last week',
  'datepicker.this_month': 'This month',
  'datepicker.last_month': 'Last month',
  'general.send': 'Send',
  copy: 'Copy',
  error: 'Error',
  'general.cancel': 'Cancel',
  'general.save': 'Save',
  'general.edit': 'Edit',
  'general.save-changes': 'Save changes',
  'order_queue.incoming': 'New',
  'order_queue.beingDelivered': 'Ongoing',
  'order_queue.finalized': 'Finalized',
  'general.add': 'Add',
  'menu.order-history': 'Order history',
  'menu.training-materials': 'Training',
  'menu.shop_info': 'Store information',
  'forgot_password.success.ok': 'Ok',

  'login.validation.invalid-password': 'Username or password is invalid, please try again.',
  'login.validation.temporary-blocked':
    'Username and password have been blocked. Please try again in 5 minutes.',

  'order_status-badge.dealerDelivered': 'Delivered',
  'order_status-badge.dealerDeclined': 'Dealer declined',
  'order_status-badge.dealerCancelled': 'Dealer cancelled',
  'order_status-badge.consumerCancelled': 'Consumer cancelled',

  'orderhistory.header.title': 'Order history',
  'orderhistory.emptyorders': 'Ops... No orders found for the search or selected period.',
  'orderhistory.genericerror': "Sorry! We couldn't load the latest orders. Try again later.",
  'orderhistory.table.summary.simple':
    '{count, plural, one {# order found} other {# orders found}}',
  'orderhistory.table.summary.opensearch':
    '{count, plural, one {# order found} other {# orders found}} with the term "{searchTerm}"',
  'orderhistory.table.header.consumer': 'Consumer',
  'orderhistory.table.header.address': 'Address',
  'orderhistory.table.header.products': 'Products',
  'orderhistory.table.header.paymentType': 'Paym.',
  'orderhistory.table.header.value': 'Value',
  'orderhistory.table.header.salesChannel': 'Channel',
  'orderhistory.table.header.driver': 'Driver',
  'orderhistory.table.header.time': 'Time',
  'orderhistory.table.header.orderPlacedAt': 'Create time',
  'orderhistory.table.header.finalizedAt': 'Finalized',
  'orderhistory.table.header.status': 'Status',
  'orderhistory.pagination.next.tooltip': 'Forward',
  'orderhistory.pagination.prev.tooltip': 'Back',
  'orderhistory.pagination.text.first_line': '{start} to {end}',
  'orderhistory.pagination.text.second_line': 'from {total} orders',
  'orderhistory.filters.openfield': 'Address or consumer',
  'orderhistory.filters.calendar.start-date-placeholder': 'Start date',
  'orderhistory.filters.calendar.end-date-placeholder': 'End date',

  'shopselector.label': 'Selected shop',

  'autocomplete.fetching-data': 'Loading results…',
  'autocomplete.not-found': 'Oops! No results found.',

  'order_channel-badge.shop': 'Phone',
  'telephoneorder.order-draft-card.continue': 'Continue filling',
  'telephoneorder.form.toast-success': 'Order added successfully!',
  'telephoneorder.form.toast-error': 'Oops! Something went wrong!',
  'telephoneorder.form.title': 'Add order by phone',
  'telephoneorder.form.button.addorder': 'Confirm order',
  'telephoneorder.form.button.continue-later': 'Continue later',
  'telephoneorder.form.field.consumerName': 'Customer name',
  'telephoneorder.form.field.consumerName.placeholder': 'E.g. Ana Maria',
  'telephoneorder.form.field.telephone': 'Telephone',
  'telephoneorder.form.field.telephone.placeholder': '(XX) XXXXX-XXXX',
  'telephoneorder.form.field.streetName': 'Address',
  'telephoneorder.form.field.streetName.placeholder': 'E.g. Street, avenue...',
  'telephoneorder.form.field.number': 'Number',
  'telephoneorder.form.field.number.placeholder': 'E.g. 1234',
  'telephoneorder.form.field.complement': 'Apartment, block, house...',
  'telephoneorder.form.field.complement.placeholder': 'E.g. First house, block 1',
  'telephoneorder.form.field.reference': 'Reference point',
  'telephoneorder.form.field.reference.placeholder': 'E.g. Next to the supermarket',
  'telephoneorder.form.field.product': 'Product',
  'telephoneorder.form.field.brand': 'Brand',
  'telephoneorder.form.field.brand.loading': 'Loading brands...',
  'telephoneorder.form.field.quantity': 'Qty.',
  'telephoneorder.form.field.paymenttype': 'Payment',
  'telephoneorder.form.field.price': 'Unit price',
  'telephoneorder.form.field.price.placeholder': 'R$ XX,XX',
  'telephoneorder.form.field.comment': 'Comments',
  'telephoneorder.form.field.comment.placeholder': 'E.g. Cash changes, tips, message to the driver',
  'telephoneorder.form.errors.price.missing': 'Insert a valid price',
  'telephoneorder.form.errors.streetName.missing': 'Insert an address',
  'telephoneorder.form.errors.telephone.invalid': 'Invalid telephone',
  'telephoneorder.form.errors.telephone.missing': 'Insert a telephone',
  'telephoneorder.form.errors.consumerName.short': 'Insert a valid name',
  'telephoneorder.form.errors.consumerName.missing': 'Insert a name',
  'telephoneorder.update-form.toast-failure': 'The changes could not be saved. Try again',

  'coverageareamap.form.link_input.label': 'Import Google MyMaps map',
  'coverageareamap.form.tips.1': 'Create/edit the map using',
  'coverageareamap.form.tips.2': 'Place a marker on the exact location of the store',
  'coverageareamap.form.tips.3': 'Draw one or more delivery areas',
  'coverageareamap.form.tips.3.1': 'A delivery area cannot have holes or intersect itself;',
  'coverageareamap.form.tips.3.2': 'Two delivery areas can overlap;',
  'coverageareamap.form.tips.4': 'Share the map in "Anyone with the link can view" mode',
  'coverageareamap.form.tips.5': 'Paste the link in the field above',
  'coverageareamap.form.tips.6':
    'Wait approximately 2 minutes to send the changes (map processing time)',
  'coverageareamap.form.errors.dealerareafetcherror':
    'Cannot fetch from google mymaps, does the map have the right permissions?',
  'coverageareamap.form.errors.dealerareazerolocations':
    'No dealer locations given, need exactly one',
  'coverageareamap.form.errors.dealerareamultiplelocations':
    'Multiple dealer locations given, need exactly one',
  'coverageareamap.form.errors.dealerareazeropolygons': 'No dealer areas given, need one or more',
  'coverageareamap.form.errors.dealerareapolygonserrors':
    'Dealer area(s) have holes or self-intersections',
  'opening_time_status.close_confirmation_modal.title':
    'What is the reason you are closing today? ',
  'opening_time_status.close_confirmation_modal.multi_shop.title':
    'Are you sure you want to close all your stores?',
  'opening_time_status.close_confirmation_modal.multi_shop.body_text':
    'When your shops are closed you will not be able to receive Chama orders. Do not forget to process ongoing orders!',
  'opening_time_status.close_confirmation_modal.body_text':
    'When the shop is closed you will not be able to receive Chama orders. Do not forget to process ongoing orders!',
  'opening_time_status.close_confirmation_modal.multi_shop.body_text2':
    'You can reopen them in any moment today, or wait until the next opening day for each store, when they will open according to their normal opening times.',
  'opening_time_status.close_confirmation_modal.body_text2':
    'You can reopen-it in any moment today, or wait until the next opening day, when it will open according to your normal opening times.',
  'form.validations.min-size': 'Must be bigger than {number} characters',
  'form.validations.max-size': 'Must be smaller than {number} characters',
  'form.validations.invalid-email': 'Invalid e-mail',
  'form.validations.invalid-phone': 'Invalid phone',
  'form.validations.required': 'Required field',
  'form.validations.only-numbers': 'Only numbers are allowed',

  'store_detail_view.store_info': 'Store information',
  'store_detail_view.app_visible_data': 'Visible data in the App',
  'store_detail_view.app_name': 'Name in the app',
  'store_detail_view.main_phone': 'Phone',
  'store_detail_view.internal_data': 'Internal data',
  'store_detail_view.cnpj.tip': 'Corporate name',
  'store_detail_view.store_email': 'Store email',
  'store_detail_view.support_phones': 'Support phone / Whatsapp',
  'store_detail_view.button.edit': 'Edit data',
  'store_detail_view.support_text': 'In case you need to change some of these informations',
  'store_detail_view.support_text_link': 'please contact Chama',
  'first_login_page.form.errors.tnc.must_check': 'You must accept terms and conditions',
  'first_login_page.form.errors.password.must_match': 'Passwords must match',
  'first_login_page.form.errors.password.short': 'Minimum 8 characters',
  'first_login_page.form.errors.phone.only_numbers': 'Only numbers are allowed',
  'first_login_page.form.errors.phone.short': 'Invalid number',
  'first_login_page.form.errors.phone.long': 'Invalid number',
  'first_login_page.form.errors.name.no_last_name': 'At least the first and last name are required',
  'first_login_page.heading.big': 'Welcome to the Chama Partner Portal!',
  'first_login_page.heading.small':
    'To continue we need you to complete your registration in the form below:',
  'first_login_page.form.links.privacy': 'Privacy Policy',
  'first_login_page.form.links.terms': 'Terms & Conditions',
  'first_login_page.form.errors.name.short': 'Too short',
  'first_login_page.form.errors.name.long': 'Too long',
  'first_login_page.form.submit_button': 'Save information',
  'first_login_page.form.required_fields': 'Required fields',
  'first_login_page.form.input.confirm_tnc':
    'I confirm that I have read the {termsLink} and the {privacyLink}',
  'first_login_page.form.input.repeat_password.placeholder': 'Repeat your password',
  'first_login_page.form.input.repeat_password': 'Confirm new password',
  'first_login_page.form.input.new_password': 'New password',
  'first_login_page.form.input.new_password.placeholder': 'Enter new password',
  'first_login_page.form.header.password': 'Access password',
  'first_login_page.form.input.phone': 'Phone',
  'first_login_page.form.input.full_name': 'Full name',
  'first_login_page.form.header.personal_data': 'Personal data',
  'first_login_page.form.email_for_login': 'Login email',

  'form.field.email': 'Email',
  'form.field.email.placeholder': 'Insert the Operator e-mail',
  'form.field.email.helper': 'Login on Partner Portal',

  'employees.invite.title': 'Add user',
  'employees.invite.message': 'Insert the operator e-mail to grant access to the shop {shop}:',
  'employees.invite.email-placeholder': 'Insert the operator e-mail',

  'employees.invite.user-added': 'User added successfully',
  'employees.invite.user-created.description':
    'For the first login, inform the temporary password to your operator:',
  'employees.invite.user-invited.description':
    'Now your operator can access the shop {shop} on Partner Portal.',
  'employees.invite.email-to-login': 'Email for login:',
  'employees.invite.temporary-password': 'Temporary password:',

  'employees_overview.edit.disable-confirmation.title': 'Deactivate user',
  'employees_overview.edit.disable-confirmation.text':
    'Deactivating the user is permanent and he will no longer have access to the {shop} on the Chama Partner Portal.',
  'employees_overview.edit.disable-confirmation.disable': 'Deactivate user',
  'employees_overview.edit.disable-confirmation.back': 'Back',

  'employees_overview.edit.employee_enabled': 'User activated successfully!',
  'employees_overview.edit.employee_disabled': 'User deactivated successfully!',

  // this locale is handled by default messages
  'employees_overview.edit.status.enable': 'Activate user',
  'employees_overview.edit.status.disable': 'Deactivate user',
  'employees_overview.edit.status.enabled_info': 'This user is deactivated',
  'employees_overview.edit.status.disable_info': 'Does this user no longer works in your shop?',
  'employees_overview.edit.role.admin': 'Administrator',
  'employees_overview.edit.role.admin_explanation':
    'Full access on the Partner Portal, including finance dashboard',
  'employees_overview.edit.role.operator': 'Operator',
  'employees_overview.edit.role.operator_explanation': 'Delivery control and price adjustments',
  'employees_overview.edit.full_name': 'Full name',
  'employees_overview.edit.email': 'E-mail',
  'employees_overview.edit.email_helper': 'Login for Partner Portal',
  'employees_overview.edit.phone': 'Phone',
  'employees.overview.edit.role_updated': 'Access permissions updated successfully!',
  'employees_overview.edit.mandatory_fields': 'Mandatory fields',
  'employees_overview.edit.user_online': 'User online',
  'employees_overview.edit.user_enabled': 'User enabled',
  'employees_overview.edit.user_disabled': 'User disabled',
  'employees_overview.edit.access_permissions': 'Access permissions',
  'employees_overview.edit.personal_data': 'Personal data',
  'employees_overview.edit.page_title': 'Edit user',
  'performance_page.menu': 'Performance',
  'performance_page.page_title': 'Performance',
  'coverageareamap.notifications.map-saved': 'Coverage area saved',
  'coverageareamap.notifications.map-save-failed': 'Saving failed, please try again',
  'general.validation.required': 'Required field',
  'general.validation.full-name': 'At least the first name and family name are required',
  'general.validation.driver-username': 'Invalid format',
  'dealer.notification.contract':
    '{shopNames} - Documents in review. Once approved, you can start your sales through Chama',
  'dealer-products.form.errors.price-out-of-range': 'This price is out of the regular price range',
  add_product: 'Add product',
  add_product_title: 'Add new product',
  remove_product_confirmation: 'Are you sure you want to remove this product?',
  brand: 'Brand',
  gas: 'Gas',
  remove: 'Remove',
  product: 'Product',
  type: 'Type',
  price: 'Price',
  generic_error_message: 'Sorry, something wrong happened.',
  'bank-account.fetch.error': 'Contact the Chama to be able to access this page',
  'bank-account.save.error': 'It was not possible to save your data, contact Chama',
  no_products_available: 'No products',
  'driverdetail.status.online.title': 'ONLINE',
  'driverdetail.status.online.description': 'real time',
  'driverdetail.status.offline.title': 'OFFLINE',
  'driverdetail.status.offline.description': 'last position',
  'ordersinfo.noorders.text': 'No deliveries until now',
  'ordersinfo.ongoing-orders.title': 'Ongoing',
  'ordersinfo.finished-orders.title': 'Finalized',
  'ordersinfo.orders-count':
    '{count, number} {count, plural, one {order} =0 {orders} other {orders}}',
  'general.order_late': 'Late',
  'general.no-data': 'No data available',
  tickets_overview_incoming: 'Incoming Orders',
  tickets_overview_incoming_empty_message: 'There are no new orders',
  'orders.all': 'All orders',
  'orders.history': 'History',
  'orders.late_orders': 'Late orders',
  'orders.range': '{filtered} of {total} orders',
  'orders.waiting.interaction': 'Waiting interaction',
  'order_details.payment_method.inAppPayment': 'In app payment',
  'order_details.sales_channel.chama': 'Chama',
  'order_details.sales_channel.shop': 'Phone',
  drivers: 'Drivers',
  'drivers.welcome': 'Welcome',
  'drivers.edition': `Driver's information`,
  'drivers.creation': 'New driver',
  'drivers.creation-success': 'Creation Success',
  'driver.driver-disable-confirmation.title': 'Disable the driver?',
  'driver.driver-disable-confirmation.text':
    'Once disabled, the driver will not be able to receive orders and make any deliveries.',
  'driver.driver-disable-confirmation.disable': 'DISABLE DRIVER',
  'driver.driver-disable-confirmation.back': 'BACK',
  'driver.enabled': 'Driver enabled successfully!',
  'driver.disabled': 'Driver disabled successfully',
  'drivers.driver.create-page-title': 'Add driver',
  'drivers.driver.create-page.add': 'Add',
  'drivers.driver.edit-page-title': 'Driver’s information',
  'drivers.driver.personal-data-title': 'Personal data',
  'drivers.driver.delivery-mode-title': 'Delivery mode',
  'drivers.driver.delivery-mode-disabled':
    'Important: only the responsible agent can change delivery mode.',
  'drivers.driver.personal-data.name': 'Full name',
  'drivers.driver.personal-data.username': 'Username',
  'drivers.driver.personal-data.username.description': 'Access in Chama Driver app',
  'drivers.driver.personal-data.required-fields': 'Required fields',
  'drivers.driver.delivery-type.pp.title': 'Partner Portal',
  'drivers.driver.delivery-type.pp.description': `Customer's order to dealership`,
  'drivers.driver.delivery-type.mobile-dealer.title': 'Mobile Dealer',
  'drivers.driver.delivery-type.mobile-dealer.description': 'Customer orders directly to driver',
  'drivers.driver.user-info.status.enabled': 'Enabled driver',
  'drivers.driver.user-info.status.disabled': 'Disabled driver',
  'drivers.driver.user-info.generate-password': 'Generate temporary password',
  'terms-and-conditions-confirmation':
    'I confirm that I have read the {termsLink} and the {privacyLink}',
  'terms-and-conditions-confirmation.terms': 'Terms & Conditions',
  'terms-and-conditions-confirmation.privacy': 'Privacy Policy',
  'drivers.create-driver': 'Add new driver',
  'drivers.page-title': 'Drivers',
  'drivers.enabled-drivers-title': 'Enabled drivers',
  'drivers.disabled-drivers-title': 'Disabled drivers',
  'drivers.no-drivers.call-to-action-description': 'Add your first driver',
  'drivers.no-drivers.call-to-action': 'Add driver',
  'drivers.no-drivers.tutorial.driver-app-value-part-1': 'With the',
  'drivers.no-drivers.tutorial.driver-app-value-part-2': 'Chama Driver',
  'drivers.no-drivers.tutorial.driver-app-value-part-3':
    'app you deliver faster and track everything in real time.',
  'drivers.no-drivers.tutorial.steps-title': 'How it works:',
  'drivers.no-drivers.tutorial.step-1': 'Add your first driver',
  'drivers.no-drivers.tutorial.step-2.part-1': 'Download the',
  'drivers.no-drivers.tutorial.step-2.part-2': 'Chama Driver',
  'drivers.no-drivers.tutorial.step-2.part-3': 'app in driver’s smartphone',
  'drivers.no-drivers.tutorial.step-3': 'Send orders to driver through Orders page',
  'dashboard.ordersReceived': 'Received',
  'dashboard.ordersLost': 'Lost',
  'dashboard.totalDeliveredOrders': 'Delivered',
  'dashboard.ordersDeliveredWithDelay': 'Delays',
  'drivers.no-email': 'No email',
  'driver.form.error.invalid-retry':
    'This driver is still being processed by our system, wait a little longer to retry',
  'driver.form.error.username-is-not-unique':
    'The username chosen already exists, please choose another one',
  'driver.form.enable-driver.description': 'This driver is disabled',
  'driver.form.disable-driver.description': 'Doesn’t this driver work for your dealership anymore?',
  'driver.form.enable-driver.action': 'ENABLE DRIVER',
  'driver.form.disable-driver.action': 'DISABLE DRIVER',
  'order_detail-eta.required': 'Please select an ETA',
  'order_detail-eta.suggested-time': 'Suggested on app',
  'order_details.order_id': 'Order ID',
  'order_details.order_id.title': 'ID',
  'order_details.order_id.copy.notification.success': 'Order ID copied successfully',
  'order_details.order_id.copy.notification.failure': 'Failed to copy order ID',

  'news.menu-entry': 'News',

  'serviceareas.title': 'Products and coverage',
  'serviceareas.title.map': 'Delivery map',
  'serviceareas.title.map-hint':
    'Consumers inside this coverage area will pay the price set in the section "Products".',
  'serviceareas.title.opening-times': 'Opening Times',
  'serviceareas.title.opening-times-hint': 'Change opening times of the shop in this area.',
  'serviceareas.title.products': 'Products',
  'serviceareas.title.products-hint':
    'Here you can change the price of your product in the selected area. To change the price for another area, select another above.',
  'serviceareas.title.select-area': 'Service area',
  'serviceareas.title.select-area-hint':
    'Each area can have different characteristics. Choose one to edit brand, price, delivery map e opening hours.',
  'serviceareas.title.area-name': 'Area name',
  'serviceareas.title.area-name-hint': 'Choose the best name for your internal control.',
  'serviceareas.map.notfound': 'This store does not have a delivery map.',
  'serviceareas.mapview.title': 'Edit delivery map',
  'serviceareas.name.label': 'Area name for internal control',
  'serviceareas.name.success': 'Area name edited successfully',
  'serviceareas.name.errors.generic': 'Error editing area name',
  'serviceareas.name.errors.area-name-exists': 'Area name already in use',
  'serviceareas.creation.title': 'Add new coverage area',
  'serviceareas.creation.create': 'Save new area',
  'serviceareas.creation.step-1.title': 'Define the coverage area',
  'serviceareas.creation.step-1.description': 'To define the coverage area, use',
  'serviceareas.creation.step-2.title': 'Paste the link to the map you created',
  'serviceareas.creation.step-2.description':
    'When you map is ready, paste the link in the field below:',
  'serviceareas.creation.step-3.title': 'Give this area a name',
  'serviceareas.creation.step-3.description':
    'To differentiate among areas, we suggest using neighbourhood names or region names.',
  'serviceareas.creation.map-link.label': 'Import map from Google My Maps',
  'serviceareas.creation.map-link.placeholder': 'Paste here the link to Google MyMaps',
  'serviceareas.creation.area-name.label.part-1': 'Area name',
  'serviceareas.creation.area-name.label.part-2': 'Only visible to dealer',
  'serviceareas.creation.area-name.placeholder': 'Input a name for this area',
  'serviceareas.creation.success': 'Area {areaName} created successfully!',
  'serviceareas.creation.errors.generic': 'Error creating coverage area.',
  'serviceareas.errors.name-too-short':
    'The name should have minimum of {minimum} characteres. Please, change it before saving',
  'serviceareas.errors.name-too-long':
    'The name should have maximum of {maximum} characters. Please, change it before saving.',
  'serviceareas.errors.name-with-sequence-of-whitespaces':
    'The name should not have 2 empty spaces in between words. Please, change it before saving.',
  'serviceareas.errors.name-with-sequence-of-special-characters':
    'The name should not have 2 special characters in sequence. Example: / or -. Please, change it before saving.',
  'serviceareas.errors.name-with-invalid-position-for-special-characters':
    'The name should not have special characters in the beggining or end. Please, change it before saving.',
  'serviceareas.errors.wrong-map-link': 'Invalid link. Verify and try again',
  'serviceareas.errors.invalid-map-shape': 'Invalid map shape.',
  'serviceareas.errors.area-name-exists': 'This name is used in another area.',
  'serviceareas.errors.failed-to-fetch-an-area': 'Error fetching coverage areas',
  'serviceareas.area-name': 'Area name',
  'serviceareas.empty.text': 'For the store to start selling, Chama needs to add a coverage area!',
  'serviceareas.empty.button.chamaagent': 'Add coverage area',
  'serviceareas.empty.button.user': 'Talk to Chama',

  'dealers.search': 'Search dealers',

  dealer_suspended: 'Suspended',

  'order_history.see_details': 'See details',
  success: 'success',

  'order_details.copy_order_details': 'Copy order details',
  'order_details.copy_dealer_phone': 'Copy telephone',

  client: 'Client',
  opens_at: 'Opens at',
  closes_at: 'Closes at',
  day: 'day',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  add: 'Add',
  to: 'to',
  'admin.editOpeningTimes.closed': 'Closed',
  loading: 'Loading',
  save_edition: 'Save edition',
  'tracking.show-driver-radius.label': 'Coverage radius',
  'tracking-page.driver.price.insert-message': 'Insert a custom price for your Mobile Dealer',
  'tracking-page.driver.price.insert': 'Insert price',
  'tracking-page.driver.price.edit': 'Edit price',
  'tracking-page.driver.price.brand': 'Brand',
  'tracking-page.driver.price.select-brand': 'Brand',
  'tracking-page.driver.price.current-price': 'Price',
  'tracking-page.driver.price.cancel': 'Cancel',
  'tracking-page.driver.price.save': 'Save',
  'tracking-page.driver.date-format': 'dddd, Do MMMM',
  'bottlesmetric.title': 'Bottles',
  'deliverymetric.title': 'Deliveries',
  order_copy: 'Copy order',
  'order-details.buttons.edit': 'Edit order',
  order_copied: 'Order copied',
  'driver.form.delivery-mode-title': 'Delivery mode',
  'driver.form.delivery-mode-subtitle': 'Select a way to deliver',
  'driver.form.delivery-type.pp.title': 'Partner Portal',
  'driver.form.delivery-type.pp.label': 'Orders from consumer to the Depot',
  'driver.form.delivery-type.mobile-dealer.title': 'Mobile Dealer',
  'driver.form.delivery-type.mobile-dealer.label': 'Orders from consumer directly to the Driver',
  'driver.form.title.stores': 'Stores',
  'driver.form.subtitle.stores': 'Select the stores for that driver',
  'driver.form.subtitle.stores-hint': 'Select at least one',
  'driver.form.subtitle.hidden-stores':
    '{quantity} {quantity, plural, one {store is} other {stores are}} not being shown in this list',
  'driver.form.error.maximum-stores':
    "It's not possible to select more than one store for this delivery mode",
  'driver.form.error.minimum-stores': 'You have to select at least one store',
  'driver.form.error.invalid-date-format': 'Invalid date format',
  'driver.form.error.invalid-date': 'Invalid date',
  'driver.form.error.expired-driver-license': 'Invalid time range',
  'driver.form.error.delivery-type': 'Select the delivery type',
  'driver.form.title.mobile-dealer': 'For Mobile Dealer, select one of the stores below',
  'driver.form.title.partner-portal': 'For Partner Portal, select the acting stores below',
  'drivers.driver-card.delivery-mode.mobile-dealer': 'Mobile Dealer',
  'drivers.driver-card.delivery-mode.territory-trackedr': 'Driver',
  'order_details.payment_method.bring_card_machine':
    'This payment is at the door. Bring the card machine',
  'order_detail-driver.title': 'Driver',
  'order_detail-driver.assign': 'Select a driver',
  'order_detail-driver.re-assign': 'Change driver',
  'order_detail-driver.selector.placeholder': 'Select a driver',
  'order_detail-driver.selector.empty': 'No drivers available',
  'order_detail-driver.selector.duration-minutes': '{ minutes } min until delivery',
  'order_detail-driver.selector.duration-hours': '{ hours } h { minutes } min until delivery',
  'order_detail-driver.selector.deliveries':
    '{deliveries, number} {deliveries, plural, one {delivery} =0 {deliveries} other {deliveries}}',
  'order_detail-driver.assign-action.cancel': 'Cancel',
  'order_detail-driver.assign-action.assign': 'Confirm the driver',
  'order_detail-driver.no-drivers-enabled-title': "You don't have enabled drivers",
  'order_detail-driver.no-drivers-enabled': 'Add driver',
  'order_detail-product-info.voucherLabel': 'Voucher',
  'order_detail-product-info.voucherDescription': 'Paid by Chama',
  'order_detail-product-info.voucherExplanation':
    'It will be paid by Chama in the next payment cycle selected',
  not_available: 'Not available',
  'order_status-message.beingDelivered': 'Being Delivered',
  'order_status-message.chamaAssigned': 'Chama is controlling this order',
  'order_status-message.otherUserControlling': 'Other user is taking care this order',
  'order_status-message.customerCancelled': 'Canceled by customer',
  'order_status-message.delivered': 'Order delivered',
  'order_status-message.dealerDeclined': 'Declined by Dealer',
  'order_status-message.dealerCancelled': 'Canceled by Dealer',
  'order_details.payment_method.cash.short': 'Cash',
  'order_details.payment_method.debit.short': 'Deb',
  'order_details.payment_method.credit.short': 'Cred',
  'order_details.payment_method.inAppPayment.short': 'App',
  'order.address': 'Address',
  'order.complement': 'Complement',
  'order.reference-point': 'Reference point',
  'order.remark': 'Tips to the driver',
  'order.cpf-title': 'Consumer demanded CPF attached to tax invoice',
  'order.cnpj-title': 'Consumer demanded CNPJ attached to tax invoice',
  'order.cpf-label': 'CPF',
  'order.cnpj-label': 'CNPJ',
  'driver_selector.driver_not_found': 'No drivers available',
  'driver_selector.delivery': 'Delivery',
  'driver_selector.loading_driver': 'Loading',

  'employee.pending-creation': 'User did not do the first login yet',

  'employees.roles.chamaagent': 'Chama Operator',
  'employees.roles.operator': 'Operator',
  'employees.roles.admin': 'Administrator',
  'employees_overview.menu': 'Users',
  'employees_overview.no-employees': 'You do not have registered users',
  'employees_overview.page_title': 'Users management',
  'employees_overview.users_registered': 'Enabled users',
  'employees_overview.users_pending': 'Pending users',
  'employees_overview.users_disabled': 'Disabled users',
  'restriction-areas.import-google-my-maps.save-error.invalid-link': `Couldn't identify the map with the link above`,
  'orders.delivery-mode.mobile.dealer': 'Mobile dealer',
  'orders.delivery-mode.unnamed-area': 'Unnamed area',
  'tnc.intro.faq': 'Got questions? Click here to learn more',
  'financial_balance.settlements.ant_fee_tier': 'Anticipation tier',
  'financial_balance.settlements.without_anticipation': 'Zero anticipation',
  'financial_balance.settlements.with_anticipation': 'With anticipation',
  'financial_balance.settlements.modal.user_selected': 'You selected anticipation tier',
  'financial_balance.settlements.modal.user_selected_zero': 'You selected no anticipation',
  'financial_balance.settlements.modal.user_selected_anticipation': 'You selected anticipation',
  'financial_balance.settlements.modal.no_acticipation': 'No anticipation',
  'financial_balance.settlements.modal.with_anticipation': 'With anticipation',
  'financial_balance.settlements.modal.anticipation_tier': 'Anticipation tier',

  'financial_balance.orders.download_csv': 'Report Download',
  'financial_balance.orders.csv_not_available': 'Report unavailable for download',
  'financial_balance.orders.csv_period_not_settled':
    'Report will be available at the end of the period',
  'financial_balance.productivity': 'Productivity',
  'financial_balance.productivity_title': 'Productivity discount',
  'financial_balance.driver-productivity.no-deliveries-message': 'No deliveries in',
  'financial_balance.driver-productivity.no-data-message': 'No productivity information for',
  'financial_balance.driver-productivity.date': 'Do [of] MMMM YYYY',
  'financial_balance.driver-productivity.loading-message': 'Loading daily productivity',
  'financial_balance.driver-productivity.header-driver': 'Driver',
  'financial_balance.driver-productivity.header-orders': 'Total delivered orders',
  'financial_balance.driver-productivity.header-discount': 'Productivity discount',
  'financial_balance.driver-productivity.footer-message': 'The shop saved:',
  'financial_balance.driver-productivity.footer-no-deliveries-message': 'No productivity discount',
  'financial_balance.driver-productivity.discount-explanation':
    'Save in Chama commission with driver daily productivity',
  'financial_balance.driver-productivity.discount-tier-to':
    'until the {to, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} delivery',
  'financial_balance.driver-productivity.discount-tier-between':
    'from the {from, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} until the {to, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} delivery',
  'financial_balance.driver-productivity.discount-tier-from':
    'after the {from, selectordinal, one {#st} two {#nd} few {#rd} other {#th}} delivery',
  'financial_balance.driver-productivity.error-message':
    'Oops! Not possible to load productivity information for this day.',
  'financial_balance.driver-productivity.refresh-tooltip': 'Update',
  'financial_balance.driver-productivity.try-again': 'Try again',
  'financial_balance.productivity_discount': 'Productivity discount',
  'ui.datepicker.ok': 'Ok',
  'ui.datepicker.cancel': 'Cancel',
  'permissions.page_permission_denied':
    'Unfortunately you do not have access to this page, please consult the administrator',
  'tracking.driver-list.card.unavailable': 'Unavailable',
  'tracking.driver-list.card.available': 'Available',
  'tracking.driver-list.card.delivering':
    'In { deliveries, number } { deliveries, plural, one { delivery } other { deliveries }}',
  'tracking.driver-list.card.mobile-dealer': 'Mobile dealer',
  'tracking.driver-list.card.territory-order': 'Driver',
  'tracking.driver-list.group.online': 'Online',
  'tracking.driver-list.group.offline': 'Offline',
  'tracking.driver-list.group.drivers':
    '{ drivers } {drivers,plural, one { driver } other { drivers }}',
  'tracking.driver-list.group.driverless-title':
    'Do you want to have more control and speed in your deliveries?',
  'tracking.driver-list.group.driverless-text':
    'Add your drivers, control your fleet and deliver faster.',
  'tracking.driver-list.group.driverless-cta': 'Add driver',
  keep_open: 'Keep open',
  close_now: 'Close now',
  'opening_time_status.close_confirmation_modal.selector.placeholder': 'Select a reason',
  'opening_time_status.close_confirmation_modal.selector.empty': 'No reasons available',
  'opening_time_status.close_confirmation_modal.reason.stock': 'No stock in the depot',
  'opening_time_status.close_confirmation_modal.reason.only-at-door-or-phone':
    'Serving only phone orders and at the dealership door',
  'opening_time_status.close_confirmation_modal.reason.high-demand':
    'High demand, cannot serve customers at the moment',
  'opening_time_status.close_confirmation_modal.reason.problems-with-pp':
    'Problems with Partner Portal',
  'opening_time_status.close_confirmation_modal.reason.finished-work-shift':
    'Finished work shift today',
  'opening_time_status.close_confirmation_modal.reason.no-drivers': 'No drivers working today',
  'opening_time_status.close_confirmation_modal.reason.other': 'Other reason',
  'opening_time_status.close_confirmation_modal.reason.title': 'Reason to close',
  'opening_time_status.close_confirmation_modal.reason.required': 'Mandatory field',

  'order_snippet.telephone_order': 'Telephone order',
  'general.logout.error': 'Error logging out, please try again',

  'feature-advertiser-popup.checkbox': 'Don’t show this message again',

  'driver-app-advertiser-popup.title': 'Welcome the Chama Driver app',
  'driver-app-advertiser-popup.text':
    'With the app you deliver faster and track everything in real time. To start register your drivers.',

  logout_confirm_description:
    'Your shop will continue to appear open or closed according to the opening hours set in Products and Coverage page',

  'driver-app-advertiser-popup.action.close': 'Close',
  'driver-app-advertiser-popup.action.register': 'Add driver',

  'service-areas-advertiser-popup.title': 'More practicality with the coverage areas!',
  'service-areas-advertiser-popup.text':
    'With them you simplify the daily operations of your shop and gain clarity in the visualization of your stores.',
  'service-areas-advertiser-popup.action.close': 'Close',
  'service-areas-advertiser-popup.action.action': 'Know more',

  'restriction-areas.success-message.area-imported': 'Success saving restriction area',
  'restriction-areas.error-message.unknown': 'Error saving restriction area',
  'restriction-areas.error-message.url-not-valid': "Couldn't identify the map with the link above",
  'restriction-areas.error-message.map-shape-not-valid': 'Invalid polygon for restriction area',
  'restriction-areas.error-message.restriction-area-not-found': 'Error saving restriction area',
  'restriction-areas.error-message.not-allowed': 'Error saving restriction area',

  'alternative-give-up-header.title.cancel': 'What is the reason for the cancellation?',
  'alternative-give-up-header.explanation.cancel':
    'If you cancel the order, Chama may reallocate your order to another dealer in the region.',
  'alternative-give-up-header.title.decline': 'What is the reason to decline?',
  'alternative-give-up-header.explanation.decline':
    'If you decline the order, Chama may reallocate your order to another dealer in the region.',
  'minutes.short': 'min',
  'add-telephone-order-button.label': 'Add order',
  'add-telephone-order.panel.tooltip.text':
    "Don't worry, order information is exclusive to your resale.",
  'add-telephone-order.panel.tooltip.link-text': 'Click here to know more about',
  'delivery_tag.accepted': 'Order accepted',
  'delivery_tag.pending': 'Prepare delivery',
  'delivery_tag.ongoing': 'Delivering',
  'delivery_tag.delivered': 'Delivered',
  'delivery_tag.rejected': 'Refused',
  'delivery_tag.cancelled': 'Cancelled',
};
/* eslint-disable max-len */

export default messages;



// WEBPACK FOOTER //
// ../utils/i18n/messages/en.js